import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FileRepositoryModel } from 'src/models/file-repository-model'

interface RenameEntryModalProps {
  open: boolean
  entry: FileRepositoryModel | null
  onClose: () => void
  onRename: (id: string, newName: string) => Promise<any>
}

export function RenameEntryModal({
  open,
  entry,
  onClose,
  onRename,
}: RenameEntryModalProps) {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (entry) setName(entry.name)
  }, [entry])

  const handleSubmit = async () => {
    if (!entry || !name.trim()) return
    setIsSubmitting(true)
    const res = await onRename(entry.id, name.trim())
    setIsSubmitting(false)
    if (res) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('fileRepository.modal.rename.title')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={t('fileRepository.modal.rename.nameLabel')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('general.button.cancel')}</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!name.trim() || isSubmitting}
        >
          {isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t('fileRepository.modal.rename.button')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
